import { render, staticRenderFns } from "./CovoitMapThumb.vue?vue&type=template&id=57b3785e&scoped=true"
import script from "./CovoitMapThumb.vue?vue&type=script&lang=js"
export * from "./CovoitMapThumb.vue?vue&type=script&lang=js"
import style0 from "./CovoitMapThumb.vue?vue&type=style&index=0&id=57b3785e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b3785e",
  null
  
)

export default component.exports